<template>
	<footer class="footer_app" v-bind:class="{'d-none': footerActive()}">
		<img src="../assets/Radboudumc-logo.png" width="200" alt="">
	</footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
  	footerActive: function(){
    	var path = this.$route.path;
	    var split = path.split('/'); 
	    console.log(split); 

	    switch(split[1]){
	    	case '':
	    		return true;
	    	break;
	    	default:
	    		return false;
	    }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue